import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Modal, Row, Button, Col } from 'react-bootstrap'

import { setChartToForm, consentFormIsInvalid } from '../reducers/chartFormReducer'
import { toggleChartRequiresRevisions, toggleChartCompleted } from '../reducers/chartFormReducer'

import LoadingScreen from '../../../components/LoadingScreen'
import { userRegionIsEU } from '../../../functions/userPermissions'
import { showPatientConsentForm } from '../../../functions/dateHandling'

const ScreeningFailureModal = (props) => {

  const {
    show,
    data,
    savingChartPhase,
    currentUser,
    site,
  } = props

  const [incompleteData, setIncompleteData] = useState([])

  useEffect(() => {
    setIncompleteData(data)
  }, [data])

  const handleSaveAndFinish = () => {
    if (props.chartForRevision) {
      props.toggleChartRequiresRevisions(props, false)
    } else {
      props.toggleChartCompleted(props, true)
    }
  }

  return (
    <Modal 
      show={show && !savingChartPhase}
      onHide={() => {
        props.toggleShow()
        props.toggleSaveAndFinishOnModalClose()
      }}
      dialogClassName="modal-wide"
    >
      <Modal.Header closeButton id='screening-failure-modal-header'>
        Screening Failure
      </Modal.Header>

      <Modal.Body>
        {props.checkingIfChartIsComplete ?
          <LoadingScreen text="Loading" />
          :
        
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              {showPatientConsentForm(props.chartCreatedDate) && consentFormIsInvalid(props) ?
                <>
                  {userRegionIsEU(currentUser) ?
                    <p>
                        The data entered has resulted in a screening failure for this patient due to the patient having <strong>not met the inclusion criteria</strong>, having <strong>met the exlusion criteria</strong>, or having an invalid or incomplete <strong>{site?.country?.toLowerCase() === 'france' ? 'date of end of opt-out period' : 'date of informed consent'}</strong> in a region where informed consent is required.
                    </p>
                    :
                    <p>
                        The data entered has resulted in a screening failure for this patient due to the patient having <strong>not met the inclusion criteria</strong> or having <strong>met the exlusion criteria</strong>.
                    </p>
                  }
                  <p>
                    If the above is incorrect, please enter the correct values for those fields in the <strong>General</strong> section of the chart before continuing.
                  </p>
                  <p>
                    If the above is correct, further data entry for this chart is no longer required. Please submit the chart to continue.
                  </p>
                </>
                :
                <>
                  <p>
                    The data entered has resulted in a screening failure for this patient. Further data entry for this chart is no longer required.
                  </p>
                  {incompleteData.length > 0 ?
                    <div>
                      <p>Please complete the following relevant sections before submitting this chart.</p>
                      <ul>
                        {incompleteData.map((item, index) =>{
                          let nestedFields = []
                          for(let key in item) {
                            if (typeof item[key] === 'object') {
                              nestedFields = [
                                ...nestedFields,
                                item[key].map((object, index) => {
                                  if (object.complete) {
                                    return null
                                  }

                                  return (
                                    <li key={object.id}>
                                      {object.model} {object.model === "ICU Admissions" || object.model === "Cefiderocol Adverse Drug Reactions" ? index + 1 : null}
                                    </li>
                                  )
                                })]
                            }
                          }
                          let formattedModelName
                          if (item.model === "Antibiotics Uses") {
                            formattedModelName = "Antibiotics Use"
                          } else {
                            formattedModelName = item.model.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")
                          }
                          return (
                            <li key={index}>
                              {formattedModelName}
                              { nestedFields.length ? <ul>{nestedFields}</ul> : null}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    :
                    <p>Please submit the chart and continue to the next patient.</p>
                  }
                </>
              }

              {incompleteData.length === 0 ?
                <div>
                  <Button variant="success" onClick={handleSaveAndFinish}>Submit Chart</Button>
                </div>
                :
                null
              }

            </Col>
          </Row>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => {
            props.toggleShow()
            props.toggleSaveAndFinishOnModalClose()
          }}
          variant="secondary"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    incompleteCharts: state.chartsReducer.incompleteCharts,
    checkingIfChartIsComplete: state.chartFormReducer.checkingIfChartIsComplete,
    metInclusionCriteria: state.chartFormReducer.metInclusionCriteria,
    metExclusionCriteria: state.chartFormReducer.metExclusionCriteria,
    informedConsentDate: state.chartFormReducer.informedConsentDate,
    localRequirementsExemption: state.chartFormReducer.localRequirementsExemption,
    site: state.chartFormReducer.site,
    chartCreatedDate: state.chartFormReducer.chartCreatedDate,
    currentUser: state.loginReducer.currentUser,
  }
}

const mapDispatchToProps = {
  setChartToForm,
  toggleChartRequiresRevisions,
  toggleChartCompleted,
}


export default connect(mapStateToProps, mapDispatchToProps)(ScreeningFailureModal)
